// Convert a plain key/value object to URLSearchParams, skipping nullish/empty.
export function objectToSearchParams(obj: Record<string, any>): URLSearchParams {
  const out = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (value == null || value === '') continue;
    out.append(key, String(value));
  }
  return out;
}
